module.exports = __webpack_public_path__ + "img/3.2e83beb5.jpg";